import AnalyticsEventTrackingItemDialog from '../AnalyticsEventTrackingItemDialog.vue';
import AppConfirmationDialog from '../AppDialogs/AppConfirmationDialog';
import ColumnsPreviewDialog from '../ColumnsPreviewDialog/ColumnsPreviewDialog';
import AddMappingToMapperDialog from '../DynamicDataMappingDialog/AddMappingToMapperDialog';
import CreateMapperDialog from '../DynamicDataMappingDialog/CreateMapperDialog';
import FinishedCreatingMapperDialog from '../DynamicDataMappingDialog/FinishedCreatingMapperDialog';
import TitleSelectionForMappingDialog from '../DynamicDataMappingDialog/TitleSelectionForMappingDialog';
import UserSchemaMappingRespondDialog from '../DynamicDataMappingDialog/UserSchemaMappingRespondDialog';
import ManualGroupDialog from '../ManualGroupDialog';
import MergeColumnDialog from '../MergeColumnDialog/MergeColumnDialog';
import OnboardingTextEditorDialog from '../OnboardingTextEditorDialog/OnboardingTextEditorDialog';
import PreviewSettingsDialog from '../PreviewSettingsDialog/PreviewSettingsDialog';
import RespondConfigurationDialog from '../RespondConfigurationDialog/RespondConfigurationDialog';
import SuggestCredentialsTypeDialog from '../SuggestCredentialsTypeDialog/SuggestCredentialsTypeDialog';
import ChooseSyncedGroupTypeAndUsersDialog from '../SyncedGroupDialog/ChooseSyncedGroupTypeAndUsersDialog';
import GroupPermissionsDialog from '../SyncedGroupDialog/GroupPermissionsDialog';
import SyncedGroupDialog from '../SyncedGroupDialog/SyncedGroupDialog';
import TestURLToolDialog from '../TestURLTool/TestURLToolDialog.vue';
import TestWithReplacingParamsDialog from '../TestWithReplacingParamsDialog.vue';
import NewProjectDialog from '../projects/NewProjectDialog';
import ProjectSettingsDialog from '../projects/settings/ProjectSettingsDialog';
import ChangePassword from '../settings/password/ChangePassword';
import AskForIntegrationPopUp from '@/components/BlockEditor/AskForIntegrationPopUp';
import FeatureAppearanceSettingsDialog from '@/components/Project/AppearanceSettings/FeatureAppearanceSettings';
import ConnectionMappingDialog from '@/components/Project/ConnectionMappingDialog';
import ContinueInstallationSignupDialog from '@/components/Project/ContinueInstallationSignupDialog';
import GmailWorkspaceSignupDialog from '@/components/Project/GmailWorkspaceSignupDialog';
import InstallationDialog from '@/components/Project/InstallationDialog';
import MappingBlockMappingDialog from '@/components/Project/MappingBlockMappingDialog';
import ModuleSettingsDialog from '@/components/Project/ModuleSettingsDialog/ModuleSettingsDialog';
import PrivacyAndSecurityDialog from '@/components/Project/PrivacyAndSecurityDialog';
import SettingsDialog from '@/components/Project/SettingsDialog';
import StudioModeRestrictedDialog from '@/components/Project/StudioModeRestrictedDialog.vue';
import AddAllowedEmailsToDomainDialog from '@/components/dialogs/AddAllowedEmailsToDomainDialog.vue';
import AddCustomDomainDialog from '@/components/dialogs/AddCustomDomainDialog.vue';
import AddEmailDomainDialog from '@/components/dialogs/AddEmailDomainDialog.vue';
import AddVerifiedEmailDialog from '@/components/dialogs/AddVerifiedEmailDialog.vue';
import AnalyticsEventCustomEventEditDialog from '@/components/dialogs/AnalyticsEventCustomEventEdit';
import AnalyticsEventTrackingSettingsDialog from '@/components/dialogs/AnalyticsEventTrackingSettingsDialog.vue';
import AppDangerConfirmationDialog from '@/components/dialogs/AppDialogs/AppDangerConfirmationDialog.vue';
import BillingPriceMapDialog from '@/components/dialogs/BillingPriceMapDialog.vue';
import CantDeleteUsedEmailTemplateDialog from '@/components/dialogs/CantDeleteUsedEmailTemplateDialog.vue';
import ChangeAccountOwnerDialog from '@/components/dialogs/ChangeAccountOwnerDialog.vue';
import ChangeEmailTemplateDialog from '@/components/dialogs/ChangeEmailTemplateDialog.vue';
import ConfigurationsMigrationDialog from '@/components/dialogs/ConfigurationsMigrationDialog';
import CouldntDowngradeBillingPlanDialog from '@/components/dialogs/CouldntDowngradeBillingPlanDialog/CouldntDowngradeBillingPlanDialog.vue';
import CreateWorkspaceDialog from '@/components/dialogs/CreateWorkspaceDialog.vue';
import CreationWizardDialog from '@/components/dialogs/CreationWizardDialog/CreationWizardDialog.vue';
import DeleteApiDocDialog from '@/components/dialogs/DeleteApiDocDialog.vue';
import DeleteBlockDialog from '@/components/dialogs/DeleteBlockDialog.vue';
import EditApiDocDialog from '@/components/dialogs/EditApiDocDialog.vue';
import EditButtonDropdownDesignDialog from '@/components/dialogs/EditButtonDropdownDesignDialog.vue';
import EditCommandBarShortcutDialog from '@/components/dialogs/EditCommandBarShortcutDialog';
import EditEmailTemplateDialog from '@/components/dialogs/EditEmailTemplateDialog.vue';
import EmailDomainInfoDialog from '@/components/dialogs/EmailDomainInfoDialog.vue';
import EmailVerificationDialog from '@/components/dialogs/EmailVerificationDialog.vue';
import EnableOveragesDialog from '@/components/dialogs/EnableOveragesDialog.vue';
import GuidedTutorialsChapterListDialog from '@/components/dialogs/GuidedTutorialsChapterListDialog';
import HelpBuildingIdeaDialog from '@/components/dialogs/HelpBuildingIdeaDialog/HelpBuildingIdeaDialog.vue';
import IFrameDialog from '@/components/dialogs/IFrameDialog.vue';
import IdeaDialog from '@/components/dialogs/IdeaDialog.vue';
import InboxDialog from '@/components/dialogs/InboxDialog.vue';
import InfoDialog from '@/components/dialogs/InfoDialog/InfoDialog';
import InstallExtDialog from '@/components/dialogs/InstallExtDialog.vue';
import InstallationCompleteDialog from '@/components/dialogs/InstallationCompleteDialog.vue';
import LeaveWorkspaceDialog from '@/components/dialogs/LeaveWorkspaceDialog.vue';
import ListingDetailsDialog from '@/components/dialogs/ListingDetailsDialog.vue';
import MeetOurTeamDialog from '@/components/dialogs/MeetOurTeamDialog/MeetOurTeamDialog.vue';
import NewOutputBlockDialog from '@/components/dialogs/NewOutputBlockDialog.vue';
import PortalAuthSettingsDialog from '@/components/dialogs/PortalAuthSettingsDialog/PortalAuthSettingsDialog.vue';
import PricingBreakdownDialog from '@/components/dialogs/PricingBreakdownDialog';
import ProductHuntDialog from '@/components/dialogs/ProductHuntDialog.vue';
import PublishFailedBecauseBillingPlanDialog from '@/components/dialogs/PublishFailedBecauseBillingPlanDialog';
import PublishFlowErrorsDialog from '@/components/dialogs/PublishFlowErrorsDialog';
import PublishWorkflowDialog from '@/components/dialogs/PublishWorkflowDialog.vue';
import ResetConvApiDocDialog from '@/components/dialogs/ResetConvApiDocDialog.vue';
import RunFailInfoDialog from '@/components/dialogs/RunFailInfoDialog.vue';
import SemiConfirmationDialog from '@/components/dialogs/SemiConfirmationDialog.vue';
import SetCustomDomainForWorkflowDialog from '@/components/dialogs/SetCustomDomainForWorkflowDialog.vue';
import ShareFeatureDialog from '@/components/dialogs/ShareFeatureDialog.vue';
import SubflowTestDialog from '@/components/dialogs/SubflowTestDialog.vue';
import ConvertToSubflowBlockDialog from '@/components/dialogs/Subflows/ConvertToSubflowBlockDialog.vue';
import NewSubflowBlockDialog from '@/components/dialogs/Subflows/NewSubflowBlockDialog.vue';
import UpdateProjectConnectionDialog from '@/components/dialogs/UpdateProjectConnectionDialog';
import UpgradeMultiplePlansDialog from '@/components/dialogs/UpgradeMultiplePlansDialog.vue';
import UpgradePlanDialog from '@/components/dialogs/UpgradePlanDialog.vue';
import WelcomeToPlyDialog from '@/components/dialogs/WelcomeToPlyDialog/WelcomeToPlyDialog';
import WorkflowsSelectionDialog from '@/components/dialogs/WorkflowsSelectionDialog.vue';
import WorkspaceChangedDialog from '@/components/dialogs/WorkspaceChangedDialog.vue';
import CollaborateNewProjectDialog from '@/components/dialogs/projects/CollaborateNewProjectDialog';
import MoveProjectDialog from '@/components/dialogs/projects/MoveProjectDialog';

const IDEA_DIALOG = 'IDEA_DIALOG';
const SHARE_DIALOG = 'SHARE_DIALOG';
const IFRAME_DIALOG = 'IFRAME_DIALOG';
const SETTINGS_DIALOG = 'SETTINGS_DIALOG';
const NEW_PROJECT_DIALOG = 'NEW_PROJECT_DIALOG';
const INTEGRATION_DIALOG = 'INTEGRATION_DIALOG';
const PRODUCT_HUNT_DIALOG = 'PRODUCT_HUNT_DIALOG';
const WELCOME_TO_PLY_DIALOG = 'WELCOME_TO_PLY_DIALOG';
const CONFIRMATION_DIALOG = 'CONFIRMATION_DIALOG';
const SEMI_CONFIRMATION_DIALOG = 'SEMI_CONFIRMATION_DIALOG';
const SYNCED_GROUP_DIALOG = 'SYNCED_GROUP_DIALOG';
const MANUAL_GROUP_DIALOG = 'MANUAL_GROUP_DIALOG';
const MERGE_COLUMN_DIALOG = 'MERGE_COLUMN_DIALOG';
const INSTALLATION_DIALOG = 'INSTALLATION_DIALOG';
const CREATE_MAPPER_DIALOG = 'CREATE_MAPPER_DIALOG';
const LISTING_DETAILS_DIALOG = 'LISTING_DETAILS_DIALOG';
const COLUMNS_PREVIEW_DIALOG = 'COLUMNS_PREVIEW_DIALOG';
const CHANGE_PASSWORD_DIALOG = 'CHANGE_PASSWORD_DIALOG';
const MODULE_SETTINGS_DIALOG = 'MODULE_SETTINGS_DIALOG';
const PREVIEW_SETTINGS_DIALOG = 'PREVIEW_SETTINGS_DIALOG';
const CONNECTION_MAPPING_DIALOG = 'CONNECTION_MAPPING_DIALOG';
const USER_SCHEMA_MAPPING_DIALOG = 'USER_SCHEMA_MAPPING_DIALOG';
const PRIVACY_AND_SECURITY_DIALOG = 'PRIVACY_AND_SECURITY_DIALOG';
const RESPOND_CONFIGURATION_DIALOG = 'RESPOND_CONFIGURATION_DIALOG';
const MAPPING_BLOCK_MAPPING_DIALOG = 'MAPPING_BLOCK_MAPPING_DIALOG';
const ADD_MAPPING_TO_MAPPER_DIALOG = 'ADD_MAPPING_TO_MAPPER_DIALOG';
const GMAIL_WORKSPACE_SIGNUP_DIALOG = 'GMAIL_WORKSPACE_SIGNUP_DIALOG';
const SUGGEST_CREDENTIALS_TYPE_DIALOG = 'SUGGEST_CREDENTIALS_TYPE_DIALOG';
const FINISHED_CREATING_MAPPER_DIALOG = 'FINISHED_CREATING_MAPPER_DIALOG';
const FEATURE_APPEARANCE_SETTINGS_DIALOG = 'FEATURE_APPEARANCE_SETTINGS_DIALOG';
const SYNCED_GROUP_TYPE_AND_USERS_DIALOG = 'SYNCED_GROUP_TYPE_AND_USERS_DIALOG';
const GROUPS_PERMISSIONS_DIALOG = 'GROUPS_PERMISSIONS_DIALOG';
const CONTINUE_INSTALLATION_SIGNUP_DIALOG = 'CONTINUE_INSTALLATION_SIGNUP_DIALOG';
const TITLE_SELECTION_FOR_MAPPING_DIALOG = 'TITLE_SELECTION_FOR_MAPPING_DIALOG';
const STUDIO_MODE_RESTRICTED_DIALOG = 'STUDIO_MODE_RESTRICTED_DIALOG';
const ONBOARDING_TEXT_EDITOR_DIALOG = 'ONBOARDING_TEXT_EDITOR_DIALOG';
const UPDATE_PROJECT_CONNECTION_DIALOG = 'UPDATE_PROJECT_CONNECTION_DIALOG';
const PROJECT_SETTINGS_DIALOG = 'PROJECT_SETTINGS_DIALOG';
const COLLABORATE_NEW_PROJECT_DIALOG = 'COLLABORATE_NEW_PROJECT_DIALOG';
const DELETE_BLOCK_DIALOG = 'DELETE_BLOCK_DIALOG';
const CREATION_WIZARD_DIALOG = 'CREATION_WIZARD_DIALOG';
const MOVE_PROJECT_DIALOG = 'MOVE_PROJECT_DIALOG';
const CHOOSE_PROJECT_DIALOG = 'CHOOSE_PROJECT_DIALOG';
const INFO_DIALOG = 'INFO_DIALOG';
const PUBLISH_FLOW_ERRORS_DIALOG = 'PUBLISH_FLOW_ERRORS_DIALOG';
const GUIDED_TUTORIALS_CHAPTER_LIST_DIALOG = 'GUIDED_TUTORIALS_CHAPTER_LIST_DIALOG';
const MEET_OUR_TEEM_DIALOG = 'MEET_OUR_TEEM_DIALOG';
const EDIT_COMMAND_BAR_SHORTCUT_DIALOG = 'EDIT_COMMAND_BAR_SHORTCUT_DIALOG';
const INSTALLATION_COMPLETE_DIALOG = 'INSTALLATION_COMPLETE_DIALOG';
const CHANGE_ACCOUNT_OWNER = 'CHANGE_ACCOUNT_OWNER';
const INBOX_DIALOG = 'INBOX_DIALOG';
const INSTALL_EXT_DIALOG = 'INSTALL_EXT_DIALOG';
const HELP_BUILDING_IDEA_DIALOG = 'HELP_BUILDING_IDEA_DIALOG';
const WORKSPACE_CHANGED_DIALOG = 'WORKSPACE_CHANGED_DIALOG';
const LEAVE_WORKSPACE_DIALOG = 'LEAVE_WORKSPACE_DIALOG';
const CREATE_WORKSPACE_DIALOG = 'CREATE_WORKSPACE_DIALOG';
const DANGER_CONFIRMATION_DIALOG = 'DANGER_CONFIRMATION_DIALOG';
const CONFIGURATIONS_MIGRATION_DIALOG = 'CONFIGURATIONS_MIGRATION_DIALOG';
const NEW_OUTPUT_BLOCK_DIALOG = 'NEW_OUTPUT_BLOCK_DIALOG';
const NEW_SUBFLOW_BLOCK_DIALOG = 'NEW_SUBFLOW_BLOCK_DIALOG';
const CONVERT_TO_SUBFLOW_BLOCK_DIALOG = 'CONVERT_TO_SUBFLOW_BLOCK_DIALOG';
const SUBFLOW_TEST_DIALOG = 'SUBFLOW_TEST_DIALOG';
const PUBLISH_WORKFLOW_DIALOG = 'PUBLISH_WORKFLOW_DIALOG';
const BUTTON_DROPDOWN_DESIGN_DIALOG = 'BUTTON_DROPDOWN_DESIGN_DIALOG';
const WORKFLOWS_SELECTION_DIALOG = 'WORKFLOWS_SELECTION_DIALOG';
const UPGRADE_PLAN_DIALOG = 'UPGRADE_PLAN_DIALOG';
const UPGRADE_MULTIPLE_PLANS_DIALOG = 'UPGRADE_MULTIPLE_PLANS_DIALOG';
const BILLING_PRICE_LIST_DIALOG = 'BILLING_PRICE_LIST_DIALOG';
const ENABLE_OVERAGES_DIALOG = 'ENABLE_OVERAGES_DIALOG';
const EDIT_API_DOC_DIALOG = 'EDIT_API_DOC_DIALOG';
const DELETE_API_DOC_DIALOG = 'DELETE_API_DOC_DIALOG';
const RESET_CONV_API_DOC_DIALOG = 'RESET_CONV_API_DOC_DIALOG';
const PORTAL_AUTH_SETTINGS_DIALOG = 'PORTAL_AUTH_SETTINGS_DIALOG';
const PRICING_BREAKDOWN_DIALOG = 'PRICING_BREAKDOWN_DIALOG';
const ADD_EMAIL_DOMAIN_DIALOG = 'ADD_EMAIL_DOMAIN_DIALOG';
const EMAIL_DOMAIN_INFO_DIALOG = 'EMAIL_DOMAIN_INFO_DIALOG';
const ADD_ALLOWED_EMAILS_TO_DOMAIN = 'ADD_ALLOWED_EMAILS_TO_DOMAIN';
const CHANGE_EMAIL_TEMPLATE_DIALOG = 'CHANGE_EMAIL_TEMPLATE_DIALOG';
const EDIT_EMAIL_TEMPLATE_DIALOG = 'EDIT_EMAIL_TEMPLATE_DIALOG';
const ADD_VERIFIED_EMAIL_DIALOG = 'ADD_VERIFIED_EMAIL_DIALOG';
const EMAIL_VERIFICATION_DIALOG = 'EMAIL_VERIFICATION_DIALOG';
const RUN_FAIL_INFO_DIALOG = 'RUN_FAIL_INFO_DIALOG';
const ADD_CUSTOM_DOMAIN_DIALOG = 'ADD_CUSTOM_DOMAIN_DIALOG';
const SET_CUSTOM_DOMAIN_FOR_WORKFLOW_DIALOG = 'SET_CUSTOM_DOMAIN_FOR_WORKFLOW_DIALOG';
const ANALYTICS_EVENT_TRACKING_SETTINGS_DIALOG = 'ANALYTICS_EVENT_TRACKING_SETTINGS_DIALOG';
const ANALYTICS_EVENT_TRACKING_ITEM_DIALOG = 'ANALYTICS_EVENT_TRACKING_ITEM_DIALOG';
const ANALYTICS_CUSTOM_EVENT_DIALOG = 'ANALYTICS_CUSTOM_EVENT_DIALOG';
const CANT_DELETE_USED_EMAIL_TEMPLATE_DIALOG = 'CANT_DELETE_USED_EMAIL_TEMPLATE_DIALOG';

const COULDNT_DOWNGRADE_BILLING_PLAN = 'COULDNT_DOWNGRADE_BILLING_PLAN';
const PUBLISH_FAILED_BECAUSE_BILLING_PLAN = 'PUBLISH_FAILED_BECAUSE_BILLING_PLAN';
const TEST_URL_TOOL_DIALOG = 'TEST_URL_TOOL_DIALOG';
const TEST_STEP_WITH_REPLACED_PARAMS = 'TEST_STEP_WITH_REPLACED_PARAMS';

export const APP_DIALOG_NAMES = {
	ANALYTICS_CUSTOM_EVENT_DIALOG,
	TEST_STEP_WITH_REPLACED_PARAMS,
	ANALYTICS_EVENT_TRACKING_ITEM_DIALOG,
	SHARE_DIALOG,
	PUBLISH_FAILED_BECAUSE_BILLING_PLAN,
	PRICING_BREAKDOWN_DIALOG,
	ENABLE_OVERAGES_DIALOG,
	COULDNT_DOWNGRADE_BILLING_PLAN,
	BILLING_PRICE_LIST_DIALOG,
	UPGRADE_PLAN_DIALOG,
	UPGRADE_MULTIPLE_PLANS_DIALOG,
	BUTTON_DROPDOWN_DESIGN_DIALOG,
	WORKFLOWS_SELECTION_DIALOG,
	EDIT_API_DOC_DIALOG,
	DELETE_API_DOC_DIALOG,
	RESET_CONV_API_DOC_DIALOG,
	PUBLISH_WORKFLOW_DIALOG,
	DANGER_CONFIRMATION_DIALOG,
	WORKSPACE_CHANGED_DIALOG,
	INSTALLATION_COMPLETE_DIALOG,
	SETTINGS_DIALOG,
	NEW_PROJECT_DIALOG,
	INTEGRATION_DIALOG,
	CONFIRMATION_DIALOG,
	SEMI_CONFIRMATION_DIALOG,
	SYNCED_GROUP_DIALOG,
	MANUAL_GROUP_DIALOG,
	MERGE_COLUMN_DIALOG,
	INSTALLATION_DIALOG,
	CREATE_MAPPER_DIALOG,
	COLUMNS_PREVIEW_DIALOG,
	CHANGE_PASSWORD_DIALOG,
	MODULE_SETTINGS_DIALOG,
	PREVIEW_SETTINGS_DIALOG,
	PROJECT_SETTINGS_DIALOG,
	CONNECTION_MAPPING_DIALOG,
	USER_SCHEMA_MAPPING_DIALOG,
	PRIVACY_AND_SECURITY_DIALOG,
	RESPOND_CONFIGURATION_DIALOG,
	ADD_MAPPING_TO_MAPPER_DIALOG,
	MAPPING_BLOCK_MAPPING_DIALOG,
	GMAIL_WORKSPACE_SIGNUP_DIALOG,
	FINISHED_CREATING_MAPPER_DIALOG,
	SUGGEST_CREDENTIALS_TYPE_DIALOG,
	TITLE_SELECTION_FOR_MAPPING_DIALOG,
	FEATURE_APPEARANCE_SETTINGS_DIALOG,
	SYNCED_GROUP_TYPE_AND_USERS_DIALOG,
	GROUPS_PERMISSIONS_DIALOG,
	CONTINUE_INSTALLATION_SIGNUP_DIALOG,
	STUDIO_MODE_RESTRICTED_DIALOG,
	ONBOARDING_TEXT_EDITOR_DIALOG,
	UPDATE_PROJECT_CONNECTION_DIALOG,
	COLLABORATE_NEW_PROJECT_DIALOG,
	DELETE_BLOCK_DIALOG,
	CREATION_WIZARD_DIALOG,
	MOVE_PROJECT_DIALOG,
	CHOOSE_PROJECT_DIALOG,
	INFO_DIALOG,
	PUBLISH_FLOW_ERRORS_DIALOG,
	GUIDED_TUTORIALS_CHAPTER_LIST_DIALOG,
	MEET_OUR_TEEM_DIALOG,
	EDIT_COMMAND_BAR_SHORTCUT_DIALOG,
	IFRAME_DIALOG,
	LISTING_DETAILS_DIALOG,
	PRODUCT_HUNT_DIALOG,
	WELCOME_TO_PLY_DIALOG,
	CHANGE_ACCOUNT_OWNER,
	INBOX_DIALOG,
	INSTALL_EXT_DIALOG,
	IDEA_DIALOG,
	HELP_BUILDING_IDEA_DIALOG,
	LEAVE_WORKSPACE_DIALOG,
	CREATE_WORKSPACE_DIALOG,
	CONFIGURATIONS_MIGRATION_DIALOG,
	NEW_OUTPUT_BLOCK_DIALOG,
	NEW_SUBFLOW_BLOCK_DIALOG,
	CONVERT_TO_SUBFLOW_BLOCK_DIALOG,
	SUBFLOW_TEST_DIALOG,
	PORTAL_AUTH_SETTINGS_DIALOG,
	ADD_EMAIL_DOMAIN_DIALOG,
	EMAIL_DOMAIN_INFO_DIALOG,
	ADD_ALLOWED_EMAILS_TO_DOMAIN,
	CHANGE_EMAIL_TEMPLATE_DIALOG,
	EDIT_EMAIL_TEMPLATE_DIALOG,
	ADD_VERIFIED_EMAIL_DIALOG,
	EMAIL_VERIFICATION_DIALOG,
	RUN_FAIL_INFO_DIALOG,
	ADD_CUSTOM_DOMAIN_DIALOG,
	SET_CUSTOM_DOMAIN_FOR_WORKFLOW_DIALOG,
	TEST_URL_TOOL_DIALOG,
	ANALYTICS_EVENT_TRACKING_SETTINGS_DIALOG,
	CANT_DELETE_USED_EMAIL_TEMPLATE_DIALOG,
};

export const DIALOG_NAME_COMPONENT_MAP = {
	ANALYTICS_EVENT_TRACKING_ITEM_DIALOG: AnalyticsEventTrackingItemDialog,
	PUBLISH_FAILED_BECAUSE_BILLING_PLAN: PublishFailedBecauseBillingPlanDialog,
	PRICING_BREAKDOWN_DIALOG: PricingBreakdownDialog,
	UPGRADE_PLAN_DIALOG: UpgradePlanDialog,
	RUN_FAIL_INFO_DIALOG: RunFailInfoDialog,
	UPGRADE_MULTIPLE_PLANS_DIALOG: UpgradeMultiplePlansDialog,
	IDEA_DIALOG: IdeaDialog,
	SHARE_DIALOG: ShareFeatureDialog,
	COULDNT_DOWNGRADE_BILLING_PLAN: CouldntDowngradeBillingPlanDialog,
	NEW_PROJECT_DIALOG: NewProjectDialog,
	SYNCED_GROUP_DIALOG: SyncedGroupDialog,
	MANUAL_GROUP_DIALOG: ManualGroupDialog,
	MERGE_COLUMN_DIALOG: MergeColumnDialog,
	CHANGE_PASSWORD_DIALOG: ChangePassword,
	INSTALLATION_DIALOG: InstallationDialog,
	CREATE_MAPPER_DIALOG: CreateMapperDialog,
	INTEGRATION_DIALOG: AskForIntegrationPopUp,
	CANT_DELETE_USED_EMAIL_TEMPLATE_DIALOG: CantDeleteUsedEmailTemplateDialog,
	CONFIRMATION_DIALOG: AppConfirmationDialog,
	SEMI_CONFIRMATION_DIALOG: SemiConfirmationDialog,
	MODULE_SETTINGS_DIALOG: ModuleSettingsDialog,
	COLUMNS_PREVIEW_DIALOG: ColumnsPreviewDialog,
	PREVIEW_SETTINGS_DIALOG: PreviewSettingsDialog,
	PROJECT_SETTINGS_DIALOG: ProjectSettingsDialog,
	CONNECTION_MAPPING_DIALOG: ConnectionMappingDialog,
	PRIVACY_AND_SECURITY_DIALOG: PrivacyAndSecurityDialog,
	ADD_MAPPING_TO_MAPPER_DIALOG: AddMappingToMapperDialog,
	RESPOND_CONFIGURATION_DIALOG: RespondConfigurationDialog,
	GMAIL_WORKSPACE_SIGNUP_DIALOG: GmailWorkspaceSignupDialog,
	USER_SCHEMA_MAPPING_DIALOG: UserSchemaMappingRespondDialog,
	SUGGEST_CREDENTIALS_TYPE_DIALOG: SuggestCredentialsTypeDialog,
	FINISHED_CREATING_MAPPER_DIALOG: FinishedCreatingMapperDialog,
	TITLE_SELECTION_FOR_MAPPING_DIALOG: TitleSelectionForMappingDialog,
	FEATURE_APPEARANCE_SETTINGS_DIALOG: FeatureAppearanceSettingsDialog,
	CONTINUE_INSTALLATION_SIGNUP_DIALOG: ContinueInstallationSignupDialog,
	SYNCED_GROUP_TYPE_AND_USERS_DIALOG: ChooseSyncedGroupTypeAndUsersDialog,
	GROUPS_PERMISSIONS_DIALOG: GroupPermissionsDialog,
	MAPPING_BLOCK_MAPPING_DIALOG: MappingBlockMappingDialog,
	SETTINGS_DIALOG: SettingsDialog,
	STUDIO_MODE_RESTRICTED_DIALOG: StudioModeRestrictedDialog,
	ONBOARDING_TEXT_EDITOR_DIALOG: OnboardingTextEditorDialog,
	UPDATE_PROJECT_CONNECTION_DIALOG: UpdateProjectConnectionDialog,
	COLLABORATE_NEW_PROJECT_DIALOG: CollaborateNewProjectDialog,
	DELETE_BLOCK_DIALOG: DeleteBlockDialog,
	CREATION_WIZARD_DIALOG: CreationWizardDialog,
	MOVE_PROJECT_DIALOG: MoveProjectDialog,
	INFO_DIALOG: InfoDialog,
	PUBLISH_FLOW_ERRORS_DIALOG: PublishFlowErrorsDialog,
	GUIDED_TUTORIALS_CHAPTER_LIST_DIALOG: GuidedTutorialsChapterListDialog,
	MEET_OUR_TEEM_DIALOG: MeetOurTeamDialog,
	EDIT_COMMAND_BAR_SHORTCUT_DIALOG: EditCommandBarShortcutDialog,
	IFRAME_DIALOG: IFrameDialog,
	LISTING_DETAILS_DIALOG: ListingDetailsDialog,
	INSTALLATION_COMPLETE_DIALOG: InstallationCompleteDialog,
	PRODUCT_HUNT_DIALOG: ProductHuntDialog,
	WELCOME_TO_PLY_DIALOG: WelcomeToPlyDialog,
	CHANGE_ACCOUNT_OWNER: ChangeAccountOwnerDialog,
	INBOX_DIALOG: InboxDialog,
	INSTALL_EXT_DIALOG: InstallExtDialog,
	HELP_BUILDING_IDEA_DIALOG: HelpBuildingIdeaDialog,
	WORKSPACE_CHANGED_DIALOG: WorkspaceChangedDialog,
	LEAVE_WORKSPACE_DIALOG: LeaveWorkspaceDialog,
	CREATE_WORKSPACE_DIALOG: CreateWorkspaceDialog,
	DANGER_CONFIRMATION_DIALOG: AppDangerConfirmationDialog,
	CONFIGURATIONS_MIGRATION_DIALOG: ConfigurationsMigrationDialog,
	NEW_OUTPUT_BLOCK_DIALOG: NewOutputBlockDialog,
	NEW_SUBFLOW_BLOCK_DIALOG: NewSubflowBlockDialog,
	CONVERT_TO_SUBFLOW_BLOCK_DIALOG: ConvertToSubflowBlockDialog,
	SUBFLOW_TEST_DIALOG: SubflowTestDialog,
	PUBLISH_WORKFLOW_DIALOG: PublishWorkflowDialog,
	BUTTON_DROPDOWN_DESIGN_DIALOG: EditButtonDropdownDesignDialog,
	WORKFLOWS_SELECTION_DIALOG: WorkflowsSelectionDialog,
	BILLING_PRICE_LIST_DIALOG: BillingPriceMapDialog,
	EDIT_API_DOC_DIALOG: EditApiDocDialog,
	DELETE_API_DOC_DIALOG: DeleteApiDocDialog,
	RESET_CONV_API_DOC_DIALOG: ResetConvApiDocDialog,
	PORTAL_AUTH_SETTINGS_DIALOG: PortalAuthSettingsDialog,
	ADD_EMAIL_DOMAIN_DIALOG: AddEmailDomainDialog,
	EMAIL_DOMAIN_INFO_DIALOG: EmailDomainInfoDialog,
	ADD_ALLOWED_EMAILS_TO_DOMAIN: AddAllowedEmailsToDomainDialog,
	CHANGE_EMAIL_TEMPLATE_DIALOG: ChangeEmailTemplateDialog,
	EDIT_EMAIL_TEMPLATE_DIALOG: EditEmailTemplateDialog,
	ADD_VERIFIED_EMAIL_DIALOG: AddVerifiedEmailDialog,
	EMAIL_VERIFICATION_DIALOG: EmailVerificationDialog,
	ADD_CUSTOM_DOMAIN_DIALOG: AddCustomDomainDialog,
	SET_CUSTOM_DOMAIN_FOR_WORKFLOW_DIALOG: SetCustomDomainForWorkflowDialog,
	TEST_URL_TOOL_DIALOG: TestURLToolDialog,
	ANALYTICS_EVENT_TRACKING_SETTINGS_DIALOG: AnalyticsEventTrackingSettingsDialog,
	ANALYTICS_CUSTOM_EVENT_DIALOG: AnalyticsEventCustomEventEditDialog,
	ENABLE_OVERAGES_DIALOG: EnableOveragesDialog,
	TEST_STEP_WITH_REPLACED_PARAMS: TestWithReplacingParamsDialog,
};
